import { render, staticRenderFns } from "./Ymx_authorization_help.vue?vue&type=template&id=ba638438&scoped=true"
import script from "./Ymx_authorization_help.vue?vue&type=script&lang=js"
export * from "./Ymx_authorization_help.vue?vue&type=script&lang=js"
import style0 from "./Ymx_authorization_help.vue?vue&type=style&index=0&id=ba638438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba638438",
  null
  
)

export default component.exports